// Link-coloured (#00A8CF) database mark supplied by design — replaces the old
// neutral data_sources glyph so the Type column's Data Source icon matches the
// product's link colour.
import DataSources from "@/icons/database.svg";
import AzureAd from "@/images/apps/azureAd.svg";
import Sailpoint from "@/images/apps/Sailpoint.svg";
import { EnumConfigType } from "@/pages/UserAttributes/types";

export const SourceMap = {
  DATA_SOURCE: "Data Source",
  AZURE_AD: "Azure AD",
  SAILPOINT: "SailPoint",
};

export type SourceType = keyof typeof SourceMap;

export const getIcon = (type: string) => {
  if (type === EnumConfigType.AZURE_AD) {
    return AzureAd;
  } else if (type === EnumConfigType.SAILPOINT) {
    return Sailpoint;
  } else {
    return DataSources;
  }
};
